export const default_country_code = { code: 'JO', label: 'Jordan', phone: '962' };

export const countries = [
    
  { code: 'Jo', label: 'Jordan', phone: '962' },
    { code: 'AE', label: 'United Arab Emirates', phone: '971' },
    
   
    { code: 'KW', label: 'Kuwait', phone: '965' },
    
    { code: 'LB', label: 'Lebanon', phone: '961' },

    { code: 'PS', label: 'Palestine, State of', phone: '970' },
   
  ];